import * as React from 'react';
import { useState, useEffect } from 'react';
import * as Moment from "moment";
import { useQuery, Direction } from './Query';
import { FilterHeader } from './QueryTable';
import Modal, { ModalSize } from '../misc/components/modal';
import { DatePickerNoForm } from '../forms/informedv2/DatePicker';

export interface Option {
    label: any;
    value: any
}

interface DateMatchSortHeaderProps {
    title: string;
    field: string;
    sortField?: string;
    automationId?: string;
}

export const DateMatchSortHeader = ({ title, field, sortField = null, automationId }: DateMatchSortHeaderProps) => {

    const [display, setDisplay] = useState(false);
    const { filters, ordering, applyOrdering } = useQuery();
    const [ordered, setOrdered] = useState<Direction>();
    const [filtered, setFiltered] = useState(false);
    sortField = sortField ?? field;

    useEffect(() => {
        const filtered = filters.some(f => f.field === field && (f.condition === 'ge' || f.condition === 'le'));
        setFiltered(filtered);
    }, [filters]);

    useEffect(() => {

        const ordered = ordering.find(o => o.field === sortField);
        setOrdered(ordered
            ? ordered.condition
            : null);
    }, [ordering]);

    const handleSort = () => {
        let direction: Direction = 'asc';

        if (ordered === 'asc')
            direction = 'desc';

        applyOrdering([{ field: sortField, condition: direction }]);
    }

    const handleFilter = () => {
        setDisplay(true);
    }

    const modal = display
        ? (
            <DateMatchFilterModal title={title} field={field} onClose={() => setDisplay(false)} />
        )
        : null;

    return (
        <>
            <FilterHeader automationId={automationId} filtered={filtered} sorted={ordered} onFilter={handleFilter} onSort={handleSort}>{title}</FilterHeader>
            {modal}
        </>
    );
}

interface DateMatchFilterModalProps {
    title: string;
    field: string;
    onClose: () => void;
}

export const DateMatchFilterModal = ({ title, field, onClose }: DateMatchFilterModalProps) => {
    const valueFormat = 'YYYY-MM-DD';

    const [valueFrom, setValueFrom] = useState<string>();
    const [valueTo, setValueTo] = useState<string>();
    const { filters, applyFilters, paging, applyPaging } = useQuery();

    useEffect(() => {


        const currentValueFrom = filters
            .filter(f => f.field === field && f.condition === 'ge')
            .flatMap(f => f.values);

        setValueFrom(currentValueFrom.length > 0 ? currentValueFrom[0] : Moment().subtract(1, 'months').format(valueFormat));

        const currentValueTo = filters
            .filter(f => f.field === field && f.condition === 'le')
            .flatMap(f => f.values);

        setValueTo(currentValueTo.length > 0 ? currentValueTo[0] : Moment().format(valueFormat));
    }, [filters]);

   

    const handleApply = () => {

        let newFilters = filters.filter(f => f.field !== field);

        newFilters = [
            ...newFilters,
            {
                field: field,
                condition: 'ge',
                values: [valueFrom],
            }, {
                field: field,
                condition: 'le',
                values: [valueTo],
            }
        ];

        applyPaging({ ...paging, page: 1 });
        applyFilters(newFilters);
        onClose();
    }

    const handleClear = () => {

        applyPaging({ ...paging, page: 1 });
        applyFilters(filters.filter(f => f.field !== field));
        onClose();
    }

    

    return (
        <Modal header={`${title} Filter`} size={ModalSize.Normal} show={true} closeModalHandler={onClose}>
            <div className="modal-body">
                <div className="row">
                    <div className='col-md-6 form-group'>
                        <label>From</label>
                        <DatePickerNoForm onChange={(value) => setValueFrom(value)} value={valueFrom} className='form-control' placeholder="DD-MM-YYYY" from={true} />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label>To</label>
                        <DatePickerNoForm onChange={(value) => setValueTo(value)} value={valueTo} className='form-control' placeholder="DD-MM-YYYY" from={false} />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleApply} data-automationid="submit-filter">OK</button>
                <button className="btn btn-danger" onClick={handleClear} data-automationid="clear-filter">Clear</button>
            </div>
        </Modal>
    );
};
